import L from 'leaflet';
import type { GeolocationPosition } from '@inloco/shared';
import { Icon } from '../ui/Icon';

interface MapControlsProps {
    mapRef: React.RefObject<L.Map | null>;
    userPosition?: GeolocationPosition | null;
}

export function MapControls({
    mapRef,
    userPosition,
}: MapControlsProps) {

    const handleZoomIn = () => {
        if (mapRef.current) {
            mapRef.current.zoomIn();
        }
    };

    const handleZoomOut = () => {
        if (mapRef.current) {
            mapRef.current.zoomOut();
        }
    };

    const centerPosition = () => {
        if (!mapRef.current || !userPosition) return;

        const { lt, lg } = userPosition;
        mapRef.current.setView([lt, lg], mapRef.current.getZoom());
        return;

    };

    return (
        <div className="absolute top-4 right-4 flex flex-col gap-1">
            <button
                onClick={handleZoomIn}
                className="btn btn-sm btn-square bg-base-100 border-base-300 hover:bg-base-200 shadow-lg"
                aria-label="Zoom in"
                title="Zoom in"
            >
                <Icon name="add" className="text-2xl leading-none" />
            </button>
            <button
                onClick={handleZoomOut}
                className="btn btn-sm btn-square bg-base-100 border-base-300 hover:bg-base-200 shadow-lg"
                aria-label="Zoom out"
                title="Zoom out"
            >
                <Icon name="remove" className="text-2xl leading-none" />
            </button>
            <button
                onClick={centerPosition}
                className="btn btn-primary btn-sm btn-square mt-5 tooltip"
                aria-label="Center position"
                title="Center position"
            >
                <Icon name="my_location" className="text-2xl leading-none" />
            </button>
        </div>
    );
}
